import api from '@/services/api'
import type { UserAuthRequest, Token, CheckResponse } from './types'

export const AuthV2Service = {
  checkToken() {
    return api.get<CheckResponse>('/v2/auth/')
  },
  tgAuth(payload: UserAuthRequest, refCode?: string | null) {
    const rf = refCode ? `?ref=${refCode}` : ''
    return api.post<Token>(`/v2/auth/${rf}`, payload)
  },
  setTimezone(timezone: string) {
    return api.put('/v2/user/timezone', { tz: timezone })
  },
}
